import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#869CE4] text-white pt-12 pb-6" data-id="element-28">
      <div className="container mx-auto px-4" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-30">
          {/* Company Info */}
          <div data-id="element-31">
            <h3 className="text-xl font-bold mb-4" data-id="element-32">Peakwave</h3>
            <ul className="space-y-3" data-id="element-33">
              <li className="flex items-start" data-id="element-34">
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0" data-id="element-35" />
                <span data-id="element-36">22 Leith Walk, Edinburgh EH6 5AA</span>
              </li>
              <li className="flex items-center" data-id="element-37">
                <Phone size={18} className="mr-2 flex-shrink-0" data-id="element-38" />
                <a href="tel:08000554969" data-id="element-39">0800 055 4969</a>
              </li>
              <li className="flex items-center" data-id="element-40">
                <Mail size={18} className="mr-2 flex-shrink-0" data-id="element-41" />
                <a href="mailto:sunitalimbu9596@gmail.com" data-id="element-42">
                  sunitalimbu9596@gmail.com
                </a>
              </li>
            </ul>
          </div>
          {/* Quick Links */}
          <div data-id="element-43">
            <h3 className="text-xl font-bold mb-4" data-id="element-44">Quick Links</h3>
            <ul className="space-y-2" data-id="element-45">
              <li data-id="element-46">
                <Link to="/" className="hover:text-[#6a7fc7] transition" data-id="element-47">
                  Home
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/service-coverage" className="hover:text-[#6a7fc7] transition" data-id="element-49">
                  Service Coverage
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/about" className="hover:text-[#6a7fc7] transition" data-id="element-51">
                  About Us
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/contact" className="hover:text-[#6a7fc7] transition" data-id="element-53">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/faq" className="hover:text-[#6a7fc7] transition" data-id="element-55">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          {/* Policies */}
          <div data-id="element-56">
            <h3 className="text-xl font-bold mb-4" data-id="element-57">Policies</h3>
            <ul className="space-y-2" data-id="element-58">
              <li data-id="element-59">
                <Link to="/cancellation-policy" className="hover:text-[#6a7fc7] transition" data-id="element-60">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/refund-policy" className="hover:text-[#6a7fc7] transition" data-id="element-62">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/privacy-policy" className="hover:text-[#6a7fc7] transition" data-id="element-64">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/terms-conditions" className="hover:text-[#6a7fc7] transition" data-id="element-66">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
          {/* Opening Hours */}
          <div data-id="element-67">
            <h3 className="text-xl font-bold mb-4" data-id="element-68">Opening Hours</h3>
            <ul className="space-y-2" data-id="element-69">
              <li className="flex justify-between" data-id="element-70">
                <span className="flex items-center" data-id="element-71">
                  <Clock size={16} className="mr-2" data-id="element-72" /> Monday:
                </span>
                <span data-id="element-73">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-74">
                <span data-id="element-75">Tuesday:</span>
                <span data-id="element-76">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-77">
                <span data-id="element-78">Wednesday:</span>
                <span data-id="element-79">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-80">
                <span data-id="element-81">Thursday:</span>
                <span data-id="element-82">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-83">
                <span data-id="element-84">Friday:</span>
                <span data-id="element-85">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-86">
                <span data-id="element-87">Saturday:</span>
                <span data-id="element-88">Closed</span>
              </li>
              <li className="flex justify-between" data-id="element-89">
                <span data-id="element-90">Sunday:</span>
                <span data-id="element-91">Closed</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Family in Kitchen Image */}
        <div className="w-full flex justify-center my-8" data-id="element-92">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a9ePQz83KUZXmSGb2FB8DG/01._Footer.png" alt="Happy family in kitchen" className="rounded-lg w-full max-w-3xl h-64 object-cover" data-id="element-93" />
        </div>
        {/* Copyright */}
        <div className="border-t border-gray-300 pt-6 mt-6 text-center" data-id="element-94">
          <p data-id="element-95">
            &copy; {new Date().getFullYear()} Peakwave. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;